module.exports = __webpack_public_path__ + "img/instagram-icon.63dc06ab.svg";